<template>
	<div>
		<el-dialog :title="EAform.title" :visible.sync="formOpen" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose">
			<el-form :model="EAform" :rules="EArules" ref="EAform" label-width="100px">
				<el-form-item label="密码" prop="pass">
					<el-input type="password" v-model="EAform.pass" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="formOpen = false">取 消</el-button>
				<el-button type="primary" @click="save()">{{EAform.Bname}}</el-button>
			</span>
		</el-dialog>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item>物种信息管理</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :md="14">
				<el-col :span="14">
					<el-input v-model="find" placeholder="请输入内容" :size="$store.state.width<$store.state.minwidth?'small':'medium'">
						<el-button slot="append" icon="el-icon-search" @click="Find()">搜索</el-button>
					</el-input>
				</el-col>
				<el-col :span="10">
					<el-button type="primary" icon="el-icon-document-add" :size="$store.state.width<$store.state.minwidth?'small':'medium'" class="add" @click="openAdd()">新增</el-button>
				</el-col>
			</el-col>
			<el-col :md="10" v-show="$store.state.width>$store.state.minwidth" class="output">
				<el-button type="primary" icon="el-icon-paperclip" size="medium" @click="exportExcel()">导出</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-table id="table" :data="$store.state.production.species.list" size="mini" stripe border class="table">
					<el-table-column type="expand" width="20">
						<template slot-scope="props">
							<el-form label-position="left">
								<el-form-item label="商品名称">
									<span>{{ props.row.date }}</span>
								</el-form-item>
								<el-form-item label="所属店铺">
									<span>{{ props.row.name }}</span>
								</el-form-item>
								<el-form-item label="商品 ID">
									<span>{{ props.row.address }}</span>
								</el-form-item>
							</el-form>
						</template>
					</el-table-column>
					<el-table-column prop="date" label="日期" width="100"></el-table-column>
					<el-table-column prop="name" label="姓名" width="60"></el-table-column>
					<el-table-column prop="address" label="地址" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" @click="Delete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="pagin">
			<el-col :span="24">
				<div>
					<el-pagination background :small="$store.state.width<$store.state.minwidth" align="center" @size-change="changeSize" @current-change="nextpage" :current-page="$store.state.production.page" :page-sizes="[20, 50, 100, 200]" :page-size="$store.state.production.pagesize" :layout="$store.state.width>$store.state.minwidth?'total, sizes, prev, pager, next, jumper':'prev, pager, next'" :total="$store.state.production.species.page.total"></el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import FileSaver from 'file-saver';
	import XLSX from 'xlsx';
	export default {
		data() {
			return {
				formOpen: false,
				EAform: {
					title: "添加",
					Bname: "添 加",
					id: '',
					pass: null
				},
				EArules: {
					
				},
				find: ''
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					
				}
			}
		},
		mounted: function () {
			this.load();
		},
		methods: {
			load()
			{
				this.getspecies();
			},
			formClose(done)
			{
				this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
			},
			changeSize(val) {
				this.$store.commit('pagesize',val);
				this.$store.commit('page',1);
				this.load();
			},
			nextpage(val) {
				this.$store.commit('page',val);
				this.load();
			},
			openEdit(value)
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.EAform.title="编辑";
					this.EAform.Bname="编 辑";
					this.EAform.id=vaue.id;
					
				});
			},
			openAdd()
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.EAform.title="添加";
					this.EAform.Bname="添 加";
				});
			},
			Delete(value)
			{
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					this.delspecies({id: value.id});
				});
			},
			save()
			{
				this.$refs['EAform'].validate((valid) => {
					if (valid) {
						if(this.EAform.title=="编辑")
						{
							let value={
								id: this.EAform.id,
								
							};
							this.editspecies(value);
							this.formOpen=false;
						}
						else
						{
							let value={
								
							};
							this.addspecies(value);
							this.formOpen=false;
						}
					}
				});
			},
			Find()
			{
				let value={
					keyword: this.find
				};
				this.$store.commit('page',1);
				this.getspecies(value);
			},
			exportExcel() {
				/* npm install --save xlsx file-saver 需要获取依赖 */
				var wb = XLSX.utils.table_to_book(document.querySelector('.table'))
				/* get binary string as output */
				var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
				} catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
				this.$message({message: '导出成功！',type: 'success'});
				return wbout
			}
		}
	}
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.output{
		text-align: right;
	}
	.table{
		margin-top: 10px;
		width: 100%;
	}
	.add{
		margin-top: 1px;
		margin-left: 5px;
	}
	.pagin{
		margin-top: 10px;
	}
</style>

<style>
	.el-message-box {
		width: 350px !important;
	}
</style>